export enum OrderItemProductionStatus {
  New = "new",
  Available = "available",
  Setup = "setup",
  Active = "active",
  Completed = "completed",
  Cancelled = "cancelled",
  Expired = "expired",
  Migrated = "migrated",
}
